import BANKS from './banks.gql';

export default BANKS;
export { BANKS };
